/* eslint-disable */
import CustomSelect from "src/shared/CustomSelect";
import MedicalTextBox from "../MedicalTextBox";
import CustomRadioButton from "src/shared/CustomRadioButton";
import Button from "@mui/material/Button";
import Resources from "src/config/Resources";

interface Props {
  formValues?: any;
  handleChanges?: any;
  handleBlurs?: any;
  error?: any;
  touch?: any;
  isReview?: boolean;
  setFieldTouch?: any;
  setFieldValue?: any;
  index: number;
  questions: Record<string, any>;
  handleRemoveClick: (index: number) => void;
}

function FamilyMedicalHistoryMembersForm({
  formValues,
  handleChanges,
  handleBlurs,
  error,
  touch,
  isReview,
  setFieldTouch,
  setFieldValue,
  index,
  questions = {},
  handleRemoveClick
}: Props) {
  return (
    <div className="xl:mt-6 lg:mt-6 md:mt-6 sm:mt-4 mt-4 flex xl:flex-row lg:flex-row md:flex-row sm:flex-col flex-col justify-between">
      {questions?.familyPersonName && (
        <div className=" xl:w-[15%] lg:w-[15%] md:w-[15%] sm:w-auto w-auto xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 ">
          <p className="mb-4 text-daintree font-montserrat text-sm font-medium">
            {questions?.familyPersonName}
          </p>

          <MedicalTextBox
            requiredStar
            label="Name of Person"
            onChange={handleChanges}
            handleBlur={handleBlurs}
            value={formValues?.medicalDetails?.familyMedicalHistory[index]?.familyPersonName}
            name={`medicalDetails.familyMedicalHistory[${index}].familyPersonName`}
            error={error?.medicalDetails?.familyMedicalHistory?.[index]?.familyPersonName}
            touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.familyPersonName}
            disabledField={isReview}
          />
        </div>
      )}
      {questions?.familyRelation && (
        <div className=" xl:w-[15%] lg:w-[15%] md:w-[20%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6">
          <p className="mb-4 text-daintree font-montserrat text-sm font-medium whitespace-nowrap">
            {questions?.familyRelation}
          </p>
          <CustomSelect
            requiredStar
            label="Relationship"
            options={["Mother", "Father", "Brother", "Sister"]}
            onChange={handleChanges}
            setFieldTouched={setFieldTouch}
            value={formValues?.medicalDetails?.familyMedicalHistory?.[index]?.familyRelation}
            name={`medicalDetails.familyMedicalHistory[${index}].familyRelation`}
            error={error?.medicalDetails?.familyMedicalHistory?.[index]?.familyRelation}
            touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.familyRelation}
            disabledField={isReview}
          />
        </div>
      )}
      {questions?.status && (
        <div className="xl:w-[20%] lg:w-[20%] md:w-[15%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6">
          {/* <p className="mb-4 text-daintree font-montserrat text-sm font-medium">Status</p> */}
          <CustomRadioButton
            requiredStar
            name={`medicalDetails.familyMedicalHistory[${index}].status`}
            label={questions?.status}
            options={["Alive", "Deceased"]}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouch}
            error={error?.medicalDetails?.familyMedicalHistory?.[index]?.status}
            touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.status}
            defaultValue={formValues?.medicalDetails?.familyMedicalHistory?.[index]?.status}
            disabled={isReview}
          />
        </div>
      )}
      {formValues.medicalDetails?.familyMedicalHistory?.[index]?.status == "Deceased" && (
        <div className="xl:w-[27%] lg:w-[27%] md:w-[27%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal whitespace-nowrap">
          {questions?.ageOfDeath && (
            <div className="">
              <p className=" text-daintree font-montserrat text-sm font-medium">
                {questions?.ageOfDeath}
              </p>
              <MedicalTextBox
                label={questions?.ageOfDeath}
                requiredStar
                className=""
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.familyMedicalHistory?.[index]?.ageOfDeath}
                name={`medicalDetails.familyMedicalHistory[${index}].ageOfDeath`}
                error={error.medicalDetails?.familyMedicalHistory?.[index]?.ageOfDeath}
                touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.ageOfDeath}
                disabledField={isReview}
              />
            </div>
          )}
          {questions?.causeDeath && (
            <div className="">
              <p className="mt-4 text-daintree font-montserrat text-sm font-medium">
                {questions?.causeDeath}
              </p>

              <CustomSelect
                requiredStar
                label={questions?.causeDeath}
                options={["Diabetes", "Hypertension", "Heart Disease", "Stroke", "Cancer"]}
                onChange={handleChanges}
                setFieldTouched={setFieldTouch}
                value={formValues?.medicalDetails?.familyMedicalHistory?.[index]?.causeDeath}
                name={`medicalDetails.familyMedicalHistory[${index}].causeDeath`}
                error={error.medicalDetails?.familyMedicalHistory?.[index]?.causeDeath}
                touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.causeDeath}
                disabledField={isReview}
              />
            </div>
          )}
        </div>
      )}
      {formValues?.medicalDetails?.familyMedicalHistory?.[index]?.status !== "Deceased" && (
        <div className="xl:w-[27%] lg:w-[27%] md:w-[27%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal whitespace-nowrap">
          {questions?.sufferingAge && (
            <div className="">
              <p className=" text-daintree font-montserrat text-sm font-medium">
                {questions?.sufferingAge}
              </p>
              <MedicalTextBox
                label={questions?.sufferingAge}
                requiredStar
                className=""
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.familyMedicalHistory[index]?.sufferingAge}
                name={`medicalDetails.familyMedicalHistory[${index}].sufferingAge`}
                error={error.medicalDetails?.familyMedicalHistory?.[index]?.sufferingAge}
                touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.sufferingAge}
                disabledField={isReview}
              />
            </div>
          )}
          {questions?.presentStateOfHealth && (
            <div className="">
              <p className="mt-4 text-daintree font-montserrat text-sm font-medium">
                {questions?.presentStateOfHealth}
              </p>

              <CustomSelect
                requiredStar
                label={questions?.presentStateOfHealth}
                options={["Healthy", "Bed Ridden", "Disabled"]}
                onChange={handleChanges}
                setFieldTouched={setFieldTouch}
                value={
                  formValues?.medicalDetails?.familyMedicalHistory?.[index]?.presentStateOfHealth
                }
                name={`medicalDetails.familyMedicalHistory[${index}].presentStateOfHealth`}
                error={error.medicalDetails?.familyMedicalHistory?.[index]?.presentStateOfHealth}
                touched={touch?.medicalDetails?.familyMedicalHistory?.[index]?.presentStateOfHealth}
                disabledField={isReview}
              />
            </div>
          )}
        </div>
      )}
      {index !== 0 && (
        <Button
          variant="outlined"
          onClick={() => handleRemoveClick(index)}
          classes={{ root: "!px-0" }}
          className="!text-black !uppercase h-10 !rounded-lg !border-2 !mr-10 w-[5%] !xl:ml-0 !lg:ml-0 !md:ml-0 !sm:ml-0 !ml-4 !xl:mt-0 !lg:mt-0 !md:mt-0 !sm:mt-6 !mt-6 !xl:mb-0 !lg:mb-0 !md:mb-0 !sm:mb-6 !mb-6 "
        >
          <img src={Resources.images.FormDetails.removeIcon} alt="remove" />
        </Button>
      )}
      {index === 0 && <div className="h-10 !mr-10 w-[7%]"></div>}
    </div>
  );
}

FamilyMedicalHistoryMembersForm.defaultProps = {
  formValues: {},
  handleChanges: "",
  handleBlurs: "",
  error: "",
  touch: "",
  isReview: false,
  setFieldTouch: "",
  setFieldValue: "",
  index: 0
};

export default FamilyMedicalHistoryMembersForm;
